export const SystemFontsEnum = {
  SYSTEM_UI: 'system-ui',
  MONOSPACE: 'Monospace',
  ARIAL: 'Arial',
  GEORGIA: 'Georgia',
  HELVETICA: 'Helvetica',
  TIMES_NEW_ROMAN: 'Times New Roman',
  COMIC_SANS_MS: 'Comic Sans MS',
  VERDANA: 'Verdana',
  TAHOMA: 'Tahoma',
  IMPACT: 'Impact',
};

export const WebFontsEnum = {
  MATERIAL_SYMBOLS_OUTLINED: 'Material Symbols Outlined',
  A_BEE_ZEE: 'ABeeZee',
  ABEL: 'Abel',
  ABHAYA_LIBRE: 'Abhaya Libre',
  ABRIL_FATFACE: 'Abril Fatface',
  ACLONICA: 'Aclonica',
  ACME: 'Acme',
  ACTOR: 'Actor',
  ADAMINA: 'Adamina',
  ADVENT_PRO: 'Advent Pro',
  AGUAFINA_SCRIPT: 'Aguafina Script',
  AKAYA_KANADAKA: 'Akaya Kanadaka',
  AKAYA_TELIVIGALA: 'Akaya Telivigala',
  AKRONIM: 'Akronim',
  ALADIN: 'Aladin',
  ALATA: 'Alata',
  ALATSI: 'Alatsi',
  ALDRICH: 'Aldrich',
  ALEF: 'Alef',
  ALEGREYA: 'Alegreya',
  ALEGREYA_SC: 'Alegreya SC',
  ALEGREYA_SANS: 'Alegreya Sans',
  ALEGREYA_SANS_SC: 'Alegreya Sans SC',
  ALEO: 'Aleo',
  ALEX_BRUSH: 'Alex Brush',
  ALFA_SLAB_ONE: 'Alfa Slab One',
  ALICE: 'Alice',
  ALIKE: 'Alike',
  ALIKE_ANGULAR: 'Alike Angular',
  ALLAN: 'Allan',
  ALLERTA: 'Allerta',
  ALLERTA_STENCIL: 'Allerta Stencil',
  ALLISON: 'Allison',
  ALLURA: 'Allura',
  ALMENDRA: 'Almendra',
  ALMENDRA_DISPLAY: 'Almendra Display',
  ALMENDRA_SC: 'Almendra SC',
  ALUMNI_SANS: 'Alumni Sans',
  AMARANTE: 'Amarante',
  AMARANTH: 'Amaranth',
  AMATIC_SC: 'Amatic SC',
  AMETHYSTA: 'Amethysta',
  AMIKO: 'Amiko',
  AMIRI: 'Amiri',
  AMITA: 'Amita',
  ANAHEIM: 'Anaheim',
  ANDADA_PRO: 'Andada Pro',
  ANDIKA: 'Andika',
  ANDIKA_NEW_BASIC: 'Andika New Basic',
  ANGKOR: 'Angkor',
  ANNIE_USE_YOUR_TELESCOPE: 'Annie Use Your Telescope',
  ANONYMOUS_PRO: 'Anonymous Pro',
  ANTIC: 'Antic',
  ANTIC_DIDONE: 'Antic Didone',
  ANTIC_SLAB: 'Antic Slab',
  ANTON: 'Anton',
  ANTONIO: 'Antonio',
  ARAPEY: 'Arapey',
  ARBUTUS: 'Arbutus',
  ARBUTUS_SLAB: 'Arbutus Slab',
  ARCHITECTS_DAUGHTER: 'Architects Daughter',
  ARCHIVO: 'Archivo',
  ARCHIVO_BLACK: 'Archivo Black',
  ARCHIVO_NARROW: 'Archivo Narrow',
  ARE_YOU_SERIOUS: 'Are You Serious',
  AREF_RUQAA: 'Aref Ruqaa',
  ARIMA_MADURAI: 'Arima Madurai',
  ARIMO: 'Arimo',
  ARIZONIA: 'Arizonia',
  ARMATA: 'Armata',
  ARSENAL: 'Arsenal',
  ARTIFIKA: 'Artifika',
  ARVO: 'Arvo',
  ARYA: 'Arya',
  ASAP: 'Asap',
  ASAP_CONDENSED: 'Asap Condensed',
  ASAR: 'Asar',
  ASSET: 'Asset',
  ASSISTANT: 'Assistant',
  ASTLOCH: 'Astloch',
  ASUL: 'Asul',
  ATHITI: 'Athiti',
  ATKINSON_HYPERLEGIBLE: 'Atkinson Hyperlegible',
  ATMA: 'Atma',
  ATOMIC_AGE: 'Atomic Age',
  AUBREY: 'Aubrey',
  AUDIOWIDE: 'Audiowide',
  AUTOUR_ONE: 'Autour One',
  AVERAGE: 'Average',
  AVERAGE_SANS: 'Average Sans',
  AVERIA_GRUESA_LIBRE: 'Averia Gruesa Libre',
  AVERIA_LIBRE: 'Averia Libre',
  AVERIA_SANS_LIBRE: 'Averia Sans Libre',
  AVERIA_SERIF_LIBRE: 'Averia Serif Libre',
  AZERET_MONO: 'Azeret Mono',
  B_612: 'B612',
  B_612_MONO: 'B612 Mono',
  BAD_SCRIPT: 'Bad Script',
  BAHIANA: 'Bahiana',
  BAHIANITA: 'Bahianita',
  BAI_JAMJUREE: 'Bai Jamjuree',
  BAKBAK_ONE: 'Bakbak One',
  BALLET: 'Ballet',
  BALOO_2: 'Baloo 2',
  BALOO_BHAI_2: 'Baloo Bhai 2',
  BALOO_BHAIJAAN_2: 'Baloo Bhaijaan 2',
  BALOO_BHAINA_2: 'Baloo Bhaina 2',
  BALOO_CHETTAN_2: 'Baloo Chettan 2',
  BALOO_DA_2: 'Baloo Da 2',
  BALOO_PAAJI_2: 'Baloo Paaji 2',
  BALOO_TAMMA_2: 'Baloo Tamma 2',
  BALOO_TAMMUDU_2: 'Baloo Tammudu 2',
  BALOO_THAMBI_2: 'Baloo Thambi 2',
  BALSAMIQ_SANS: 'Balsamiq Sans',
  BALTHAZAR: 'Balthazar',
  BANGERS: 'Bangers',
  BARLOW: 'Barlow',
  BARLOW_CONDENSED: 'Barlow Condensed',
  BARLOW_SEMI_CONDENSED: 'Barlow Semi Condensed',
  BARRIECITO: 'Barriecito',
  BARRIO: 'Barrio',
  BASIC: 'Basic',
  BASKERVVILLE: 'Baskervville',
  BATTAMBANG: 'Battambang',
  BAUMANS: 'Baumans',
  BAYON: 'Bayon',
  BE_VIETNAM_PRO: 'Be Vietnam Pro',
  BEBAS_NEUE: 'Bebas Neue',
  BELGRANO: 'Belgrano',
  BELLEFAIR: 'Bellefair',
  BELLEZA: 'Belleza',
  BELLOTA: 'Bellota',
  BELLOTA_TEXT: 'Bellota Text',
  BENCH_NINE: 'BenchNine',
  BENNE: 'Benne',
  BENTHAM: 'Bentham',
  BERKSHIRE_SWASH: 'Berkshire Swash',
  BESLEY: 'Besley',
  BETH_ELLEN: 'Beth Ellen',
  BEVAN: 'Bevan',
  BHU_TUKA_EXPANDED_ONE: 'BhuTuka Expanded One',
  BIG_SHOULDERS_DISPLAY: 'Big Shoulders Display',
  BIG_SHOULDERS_INLINE_DISPLAY: 'Big Shoulders Inline Display',
  BIG_SHOULDERS_INLINE_TEXT: 'Big Shoulders Inline Text',
  BIG_SHOULDERS_STENCIL_DISPLAY: 'Big Shoulders Stencil Display',
  BIG_SHOULDERS_STENCIL_TEXT: 'Big Shoulders Stencil Text',
  BIG_SHOULDERS_TEXT: 'Big Shoulders Text',
  BIGELOW_RULES: 'Bigelow Rules',
  BIGSHOT_ONE: 'Bigshot One',
  BILBO: 'Bilbo',
  BILBO_SWASH_CAPS: 'Bilbo Swash Caps',
  BIO_RHYME: 'BioRhyme',
  BIO_RHYME_EXPANDED: 'BioRhyme Expanded',
  BIRTHSTONE: 'Birthstone',
  BIRTHSTONE_BOUNCE: 'Birthstone Bounce',
  BIRYANI: 'Biryani',
  BITTER: 'Bitter',
  BLACK_AND_WHITE_PICTURE: 'Black And White Picture',
  BLACK_HAN_SANS: 'Black Han Sans',
  BLACK_OPS_ONE: 'Black Ops One',
  BLINKER: 'Blinker',
  BODONI_MODA: 'Bodoni Moda',
  BOKOR: 'Bokor',
  BONA_NOVA: 'Bona Nova',
  BONBON: 'Bonbon',
  BONHEUR_ROYALE: 'Bonheur Royale',
  BOOGALOO: 'Boogaloo',
  BOWLBY_ONE: 'Bowlby One',
  BOWLBY_ONE_SC: 'Bowlby One SC',
  BRAWLER: 'Brawler',
  BREE_SERIF: 'Bree Serif',
  BRYGADA_1918: 'Brygada 1918',
  BUBBLEGUM_SANS: 'Bubblegum Sans',
  BUBBLER_ONE: 'Bubbler One',
  BUENARD: 'Buenard',
  BUNGEE: 'Bungee',
  BUNGEE_HAIRLINE: 'Bungee Hairline',
  BUNGEE_INLINE: 'Bungee Inline',
  BUNGEE_OUTLINE: 'Bungee Outline',
  BUNGEE_SHADE: 'Bungee Shade',
  BUTCHERMAN: 'Butcherman',
  BUTTERFLY_KIDS: 'Butterfly Kids',
  CABIN: 'Cabin',
  CABIN_CONDENSED: 'Cabin Condensed',
  CABIN_SKETCH: 'Cabin Sketch',
  CAESAR_DRESSING: 'Caesar Dressing',
  CAGLIOSTRO: 'Cagliostro',
  CAIRO: 'Cairo',
  CALADEA: 'Caladea',
  CALISTOGA: 'Calistoga',
  CALLIGRAFFITTI: 'Calligraffitti',
  CAMBAY: 'Cambay',
  CAMBO: 'Cambo',
  CANDAL: 'Candal',
  CANTARELL: 'Cantarell',
  CANTATA_ONE: 'Cantata One',
  CANTORA_ONE: 'Cantora One',
  CAPRIOLA: 'Capriola',
  CARAMEL: 'Caramel',
  CARATTERE: 'Carattere',
  CARDO: 'Cardo',
  CARME: 'Carme',
  CARROIS_GOTHIC: 'Carrois Gothic',
  CARROIS_GOTHIC_SC: 'Carrois Gothic SC',
  CARTER_ONE: 'Carter One',
  CASTORO: 'Castoro',
  CATAMARAN: 'Catamaran',
  CAUDEX: 'Caudex',
  CAVEAT: 'Caveat',
  CAVEAT_BRUSH: 'Caveat Brush',
  CEDARVILLE_CURSIVE: 'Cedarville Cursive',
  CEVICHE_ONE: 'Ceviche One',
  CHAKRA_PETCH: 'Chakra Petch',
  CHANGA: 'Changa',
  CHANGA_ONE: 'Changa One',
  CHANGO: 'Chango',
  CHARM: 'Charm',
  CHARMONMAN: 'Charmonman',
  CHATHURA: 'Chathura',
  CHAU_PHILOMENE_ONE: 'Chau Philomene One',
  CHELA_ONE: 'Chela One',
  CHELSEA_MARKET: 'Chelsea Market',
  CHERISH: 'Cherish',
  CHERRY_CREAM_SODA: 'Cherry Cream Soda',
  CHERRY_SWASH: 'Cherry Swash',
  CHEWY: 'Chewy',
  CHICLE: 'Chicle',
  CHILANKA: 'Chilanka',
  CHIVO: 'Chivo',
  CHONBURI: 'Chonburi',
  CINZEL: 'Cinzel',
  CINZEL_DECORATIVE: 'Cinzel Decorative',
  CLICKER_SCRIPT: 'Clicker Script',
  CODA: 'Coda',
  CODYSTAR: 'Codystar',
  COINY: 'Coiny',
  COMBO: 'Combo',
  COMFORTAA: 'Comfortaa',
  COMFORTER: 'Comforter',
  COMFORTER_BRUSH: 'Comforter Brush',
  COMIC_NEUE: 'Comic Neue',
  COMING_SOON: 'Coming Soon',
  COMMISSIONER: 'Commissioner',
  CONCERT_ONE: 'Concert One',
  CONDIMENT: 'Condiment',
  CONTRAIL_ONE: 'Contrail One',
  CONVERGENCE: 'Convergence',
  COOKIE: 'Cookie',
  COPSE: 'Copse',
  CORBEN: 'Corben',
  CORINTHIA: 'Corinthia',
  CORMORANT: 'Cormorant',
  CORMORANT_GARAMOND: 'Cormorant Garamond',
  CORMORANT_INFANT: 'Cormorant Infant',
  CORMORANT_SC: 'Cormorant SC',
  CORMORANT_UNICASE: 'Cormorant Unicase',
  CORMORANT_UPRIGHT: 'Cormorant Upright',
  COURGETTE: 'Courgette',
  COURIER_PRIME: 'Courier Prime',
  COUSINE: 'Cousine',
  COUSTARD: 'Coustard',
  COVERED_BY_YOUR_GRACE: 'Covered By Your Grace',
  CRAFTY_GIRLS: 'Crafty Girls',
  CREEPSTER: 'Creepster',
  CRETE_ROUND: 'Crete Round',
  CRIMSON_PRO: 'Crimson Pro',
  CROISSANT_ONE: 'Croissant One',
  CRUSHED: 'Crushed',
  CUPRUM: 'Cuprum',
  CUTE_FONT: 'Cute Font',
  CUTIVE: 'Cutive',
  CUTIVE_MONO: 'Cutive Mono',
  DM_MONO: 'DM Mono',
  DM_SANS: 'DM Sans',
  DM_SERIF_DISPLAY: 'DM Serif Display',
  DM_SERIF_TEXT: 'DM Serif Text',
  DAMION: 'Damion',
  DANCING_SCRIPT: 'Dancing Script',
  DANGREK: 'Dangrek',
  DARKER_GROTESQUE: 'Darker Grotesque',
  DAVID_LIBRE: 'David Libre',
  DAWNING_OF_A_NEW_DAY: 'Dawning of a New Day',
  DAYS_ONE: 'Days One',
  DEKKO: 'Dekko',
  DELA_GOTHIC_ONE: 'Dela Gothic One',
  DELIUS: 'Delius',
  DELIUS_SWASH_CAPS: 'Delius Swash Caps',
  DELIUS_UNICASE: 'Delius Unicase',
  DELLA_RESPIRA: 'Della Respira',
  DENK_ONE: 'Denk One',
  DEVONSHIRE: 'Devonshire',
  DHURJATI: 'Dhurjati',
  DIDACT_GOTHIC: 'Didact Gothic',
  DIPLOMATA: 'Diplomata',
  DIPLOMATA_SC: 'Diplomata SC',
  DO_HYEON: 'Do Hyeon',
  DOKDO: 'Dokdo',
  DOMINE: 'Domine',
  DONEGAL_ONE: 'Donegal One',
  DONGLE: 'Dongle',
  DOPPIO_ONE: 'Doppio One',
  DORSA: 'Dorsa',
  DOSIS: 'Dosis',
  DOT_GOTHIC_16: 'DotGothic16',
  DR_SUGIYAMA: 'Dr Sugiyama',
  DURU_SANS: 'Duru Sans',
  DYNALIGHT: 'Dynalight',
  EB_GARAMOND: 'EB Garamond',
  EAGLE_LAKE: 'Eagle Lake',
  EAST_SEA_DOKDO: 'East Sea Dokdo',
  EATER: 'Eater',
  ECONOMICA: 'Economica',
  ECZAR: 'Eczar',
  EL_MESSIRI: 'El Messiri',
  ELECTROLIZE: 'Electrolize',
  ELSIE: 'Elsie',
  ELSIE_SWASH_CAPS: 'Elsie Swash Caps',
  EMBLEMA_ONE: 'Emblema One',
  EMILYS_CANDY: 'Emilys Candy',
  ENCODE_SANS: 'Encode Sans',
  ENCODE_SANS_CONDENSED: 'Encode Sans Condensed',
  ENCODE_SANS_EXPANDED: 'Encode Sans Expanded',
  ENCODE_SANS_SC: 'Encode Sans SC',
  ENCODE_SANS_SEMI_CONDENSED: 'Encode Sans Semi Condensed',
  ENCODE_SANS_SEMI_EXPANDED: 'Encode Sans Semi Expanded',
  ENGAGEMENT: 'Engagement',
  ENGLEBERT: 'Englebert',
  ENRIQUETA: 'Enriqueta',
  EPHESIS: 'Ephesis',
  EPILOGUE: 'Epilogue',
  ERICA_ONE: 'Erica One',
  ESTEBAN: 'Esteban',
  ESTONIA: 'Estonia',
  EUPHORIA_SCRIPT: 'Euphoria Script',
  EWERT: 'Ewert',
  EXO: 'Exo',
  EXO_2: 'Exo 2',
  EXPLETUS_SANS: 'Expletus Sans',
  EXPLORA: 'Explora',
  FAHKWANG: 'Fahkwang',
  FANWOOD_TEXT: 'Fanwood Text',
  FARRO: 'Farro',
  FARSAN: 'Farsan',
  FASCINATE: 'Fascinate',
  FASCINATE_INLINE: 'Fascinate Inline',
  FASTER_ONE: 'Faster One',
  FASTHAND: 'Fasthand',
  FAUNA_ONE: 'Fauna One',
  FAUSTINA: 'Faustina',
  FEDERANT: 'Federant',
  FEDERO: 'Federo',
  FELIPA: 'Felipa',
  FENIX: 'Fenix',
  FESTIVE: 'Festive',
  FINGER_PAINT: 'Finger Paint',
  FIRA_CODE: 'Fira Code',
  FIRA_MONO: 'Fira Mono',
  FIRA_SANS: 'Fira Sans',
  FIRA_SANS_CONDENSED: 'Fira Sans Condensed',
  FIRA_SANS_EXTRA_CONDENSED: 'Fira Sans Extra Condensed',
  FJALLA_ONE: 'Fjalla One',
  FJORD_ONE: 'Fjord One',
  FLAMENCO: 'Flamenco',
  FLAVORS: 'Flavors',
  FLEUR_DE_LEAH: 'Fleur De Leah',
  FLOW_BLOCK: 'Flow Block',
  FLOW_CIRCULAR: 'Flow Circular',
  FLOW_ROUNDED: 'Flow Rounded',
  FONDAMENTO: 'Fondamento',
  FONTDINER_SWANKY: 'Fontdiner Swanky',
  FORUM: 'Forum',
  FRANCOIS_ONE: 'Francois One',
  FRANK_RUHL_LIBRE: 'Frank Ruhl Libre',
  FRAUNCES: 'Fraunces',
  FRECKLE_FACE: 'Freckle Face',
  FREDERICKA_THE_GREAT: 'Fredericka the Great',
  FREDOKA: 'Fredoka',
  FREDOKA_ONE: 'Fredoka One',
  FREEHAND: 'Freehand',
  FRESCA: 'Fresca',
  FRIJOLE: 'Frijole',
  FRUKTUR: 'Fruktur',
  FUGAZ_ONE: 'Fugaz One',
  FUGGLES: 'Fuggles',
  FUZZY_BUBBLES: 'Fuzzy Bubbles',
  GABRIELA: 'Gabriela',
  GAEGU: 'Gaegu',
  GAFATA: 'Gafata',
  GALADA: 'Galada',
  GALDEANO: 'Galdeano',
  GALINDO: 'Galindo',
  GAMJA_FLOWER: 'Gamja Flower',
  GAYATHRI: 'Gayathri',
  GELASIO: 'Gelasio',
  GEMUNU_LIBRE: 'Gemunu Libre',
  GENOS: 'Genos',
  GENTIUM_BASIC: 'Gentium Basic',
  GENTIUM_BOOK_BASIC: 'Gentium Book Basic',
  GEO: 'Geo',
  GEORAMA: 'Georama',
  GEOSTAR: 'Geostar',
  GEOSTAR_FILL: 'Geostar Fill',
  GERMANIA_ONE: 'Germania One',
  GIDEON_ROMAN: 'Gideon Roman',
  GIDUGU: 'Gidugu',
  GILDA_DISPLAY: 'Gilda Display',
  GIRASSOL: 'Girassol',
  GIVE_YOU_GLORY: 'Give You Glory',
  GLASS_ANTIQUA: 'Glass Antiqua',
  GLEGOO: 'Glegoo',
  GLORIA_HALLELUJAH: 'Gloria Hallelujah',
  GLORY: 'Glory',
  GLUTEN: 'Gluten',
  GOBLIN_ONE: 'Goblin One',
  GOCHI_HAND: 'Gochi Hand',
  GOLDMAN: 'Goldman',
  GORDITAS: 'Gorditas',
  GOTHIC_A_1: 'Gothic A1',
  GOTU: 'Gotu',
  GOUDY_BOOKLETTER_1911: 'Goudy Bookletter 1911',
  GOWUN_BATANG: 'Gowun Batang',
  GOWUN_DODUM: 'Gowun Dodum',
  GRADUATE: 'Graduate',
  GRAND_HOTEL: 'Grand Hotel',
  GRANDSTANDER: 'Grandstander',
  GRAVITAS_ONE: 'Gravitas One',
  GREAT_VIBES: 'Great Vibes',
  GRECHEN_FUEMEN: 'Grechen Fuemen',
  GRENZE: 'Grenze',
  GRENZE_GOTISCH: 'Grenze Gotisch',
  GREY_QO: 'Grey Qo',
  GRIFFY: 'Griffy',
  GRUPPO: 'Gruppo',
  GUDEA: 'Gudea',
  GUGI: 'Gugi',
  GUPTER: 'Gupter',
  GURAJADA: 'Gurajada',
  GWENDOLYN: 'Gwendolyn',
  HABIBI: 'Habibi',
  HACHI_MARU_POP: 'Hachi Maru Pop',
  HAHMLET: 'Hahmlet',
  HALANT: 'Halant',
  HAMMERSMITH_ONE: 'Hammersmith One',
  HANALEI: 'Hanalei',
  HANALEI_FILL: 'Hanalei Fill',
  HANDLEE: 'Handlee',
  HANUMAN: 'Hanuman',
  HAPPY_MONKEY: 'Happy Monkey',
  HARMATTAN: 'Harmattan',
  HEADLAND_ONE: 'Headland One',
  HEEBO: 'Heebo',
  HENNY_PENNY: 'Henny Penny',
  HEPTA_SLAB: 'Hepta Slab',
  HERR_VON_MUELLERHOFF: 'Herr Von Muellerhoff',
  HI_MELODY: 'Hi Melody',
  HINA_MINCHO: 'Hina Mincho',
  HIND: 'Hind',
  HIND_GUNTUR: 'Hind Guntur',
  HIND_MADURAI: 'Hind Madurai',
  HIND_SILIGURI: 'Hind Siliguri',
  HIND_VADODARA: 'Hind Vadodara',
  HOLTWOOD_ONE_SC: 'Holtwood One SC',
  HOMEMADE_APPLE: 'Homemade Apple',
  HOMENAJE: 'Homenaje',
  HUBBALLI: 'Hubballi',
  HURRICANE: 'Hurricane',
  IBM_PLEX_MONO: 'IBM Plex Mono',
  IBM_PLEX_SANS: 'IBM Plex Sans',
  IBM_PLEX_SANS_ARABIC: 'IBM Plex Sans Arabic',
  IBM_PLEX_SANS_CONDENSED: 'IBM Plex Sans Condensed',
  IBM_PLEX_SANS_DEVANAGARI: 'IBM Plex Sans Devanagari',
  IBM_PLEX_SANS_HEBREW: 'IBM Plex Sans Hebrew',
  IBM_PLEX_SANS_KR: 'IBM Plex Sans KR',
  IBM_PLEX_SANS_THAI: 'IBM Plex Sans Thai',
  IBM_PLEX_SANS_THAI_LOOPED: 'IBM Plex Sans Thai Looped',
  IBM_PLEX_SERIF: 'IBM Plex Serif',
  IM_FELL_DW_PICA: 'IM Fell DW Pica',
  IM_FELL_DW_PICA_SC: 'IM Fell DW Pica SC',
  IM_FELL_DOUBLE_PICA: 'IM Fell Double Pica',
  IM_FELL_DOUBLE_PICA_SC: 'IM Fell Double Pica SC',
  IM_FELL_ENGLISH: 'IM Fell English',
  IM_FELL_ENGLISH_SC: 'IM Fell English SC',
  IM_FELL_FRENCH_CANON: 'IM Fell French Canon',
  IM_FELL_FRENCH_CANON_SC: 'IM Fell French Canon SC',
  IM_FELL_GREAT_PRIMER: 'IM Fell Great Primer',
  IM_FELL_GREAT_PRIMER_SC: 'IM Fell Great Primer SC',
  IBARRA_REAL_NOVA: 'Ibarra Real Nova',
  ICEBERG: 'Iceberg',
  ICELAND: 'Iceland',
  IMBUE: 'Imbue',
  IMPERIAL_SCRIPT: 'Imperial Script',
  IMPRIMA: 'Imprima',
  INCONSOLATA: 'Inconsolata',
  INDER: 'Inder',
  INDIE_FLOWER: 'Indie Flower',
  INIKA: 'Inika',
  INKNUT_ANTIQUA: 'Inknut Antiqua',
  INRIA_SANS: 'Inria Sans',
  INRIA_SERIF: 'Inria Serif',
  INSPIRATION: 'Inspiration',
  INTER: 'Inter',
  IRISH_GROVER: 'Irish Grover',
  ISLAND_MOMENTS: 'Island Moments',
  ISTOK_WEB: 'Istok Web',
  ITALIANA: 'Italiana',
  ITALIANNO: 'Italianno',
  ITIM: 'Itim',
  JACQUES_FRANCOIS: 'Jacques Francois',
  JACQUES_FRANCOIS_SHADOW: 'Jacques Francois Shadow',
  JALDI: 'Jaldi',
  JET_BRAINS_MONO: 'JetBrains Mono',
  JIM_NIGHTSHADE: 'Jim Nightshade',
  JOCKEY_ONE: 'Jockey One',
  JOLLY_LODGER: 'Jolly Lodger',
  JOMHURIA: 'Jomhuria',
  JOMOLHARI: 'Jomolhari',
  JOSEFIN_SANS: 'Josefin Sans',
  JOSEFIN_SLAB: 'Josefin Slab',
  JOST: 'Jost',
  JOTI_ONE: 'Joti One',
  JUA: 'Jua',
  JUDSON: 'Judson',
  JULEE: 'Julee',
  JULIUS_SANS_ONE: 'Julius Sans One',
  JUNGE: 'Junge',
  JURA: 'Jura',
  JUST_ANOTHER_HAND: 'Just Another Hand',
  JUST_ME_AGAIN_DOWN_HERE: 'Just Me Again Down Here',
  K_2_D: 'K2D',
  KADWA: 'Kadwa',
  KAISEI_DECOL: 'Kaisei Decol',
  KAISEI_HARUNO_UMI: 'Kaisei HarunoUmi',
  KAISEI_OPTI: 'Kaisei Opti',
  KAISEI_TOKUMIN: 'Kaisei Tokumin',
  KALAM: 'Kalam',
  KAMERON: 'Kameron',
  KANIT: 'Kanit',
  KARANTINA: 'Karantina',
  KARLA: 'Karla',
  KARMA: 'Karma',
  KATIBEH: 'Katibeh',
  KAUSHAN_SCRIPT: 'Kaushan Script',
  KAVIVANAR: 'Kavivanar',
  KAVOON: 'Kavoon',
  KEANIA_ONE: 'Keania One',
  KELLY_SLAB: 'Kelly Slab',
  KENIA: 'Kenia',
  KHAND: 'Khand',
  KHULA: 'Khula',
  KINGS: 'Kings',
  KIRANG_HAERANG: 'Kirang Haerang',
  KITE_ONE: 'Kite One',
  KIWI_MARU: 'Kiwi Maru',
  KLEE_ONE: 'Klee One',
  KNEWAVE: 'Knewave',
  KO_HO: 'KoHo',
  KODCHASAN: 'Kodchasan',
  KOH_SANTEPHEAP: 'Koh Santepheap',
  KOLKER_BRUSH: 'Kolker Brush',
  KOSUGI: 'Kosugi',
  KOSUGI_MARU: 'Kosugi Maru',
  KOTTA_ONE: 'Kotta One',
  KOULEN: 'Koulen',
  KRANKY: 'Kranky',
  KREON: 'Kreon',
  KRISTI: 'Kristi',
  KRONA_ONE: 'Krona One',
  KRUB: 'Krub',
  KUFAM: 'Kufam',
  KULIM_PARK: 'Kulim Park',
  KUMAR_ONE: 'Kumar One',
  KUMAR_ONE_OUTLINE: 'Kumar One Outline',
  KUMBH_SANS: 'Kumbh Sans',
  KURALE: 'Kurale',
  LA_BELLE_AURORE: 'La Belle Aurore',
  LACQUER: 'Lacquer',
  LAILA: 'Laila',
  LAKKI_REDDY: 'Lakki Reddy',
  LALEZAR: 'Lalezar',
  LANCELOT: 'Lancelot',
  LANGAR: 'Langar',
  LATEEF: 'Lateef',
  LATO: 'Lato',
  LEAGUE_GOTHIC: 'League Gothic',
  LEAGUE_SCRIPT: 'League Script',
  LEAGUE_SPARTAN: 'League Spartan',
  LECKERLI_ONE: 'Leckerli One',
  LEDGER: 'Ledger',
  LEKTON: 'Lekton',
  LEMON: 'Lemon',
  LEMONADA: 'Lemonada',
  LEXEND: 'Lexend',
  LEXEND_DECA: 'Lexend Deca',
  LEXEND_EXA: 'Lexend Exa',
  LEXEND_GIGA: 'Lexend Giga',
  LEXEND_MEGA: 'Lexend Mega',
  LEXEND_PETA: 'Lexend Peta',
  LEXEND_TERA: 'Lexend Tera',
  LEXEND_ZETTA: 'Lexend Zetta',
  LIBRE_BARCODE_128: 'Libre Barcode 128',
  LIBRE_BARCODE_128_TEXT: 'Libre Barcode 128 Text',
  LIBRE_BARCODE_39: 'Libre Barcode 39',
  LIBRE_BARCODE_39_EXTENDED: 'Libre Barcode 39 Extended',
  LIBRE_BARCODE_39_EXTENDED_TEXT: 'Libre Barcode 39 Extended Text',
  LIBRE_BARCODE_39_TEXT: 'Libre Barcode 39 Text',
  LIBRE_BARCODE_EAN_13_TEXT: 'Libre Barcode EAN13 Text',
  LIBRE_BASKERVILLE: 'Libre Baskerville',
  LIBRE_CASLON_DISPLAY: 'Libre Caslon Display',
  LIBRE_CASLON_TEXT: 'Libre Caslon Text',
  LIBRE_FRANKLIN: 'Libre Franklin',
  LICORICE: 'Licorice',
  LIFE_SAVERS: 'Life Savers',
  LILITA_ONE: 'Lilita One',
  LILY_SCRIPT_ONE: 'Lily Script One',
  LIMELIGHT: 'Limelight',
  LINDEN_HILL: 'Linden Hill',
  LITERATA: 'Literata',
  LIU_JIAN_MAO_CAO: 'Liu Jian Mao Cao',
  LIVVIC: 'Livvic',
  LOBSTER: 'Lobster',
  LOBSTER_TWO: 'Lobster Two',
  LONDRINA_OUTLINE: 'Londrina Outline',
  LONDRINA_SHADOW: 'Londrina Shadow',
  LONDRINA_SKETCH: 'Londrina Sketch',
  LONDRINA_SOLID: 'Londrina Solid',
  LONG_CANG: 'Long Cang',
  LORA: 'Lora',
  LOVE_LIGHT: 'Love Light',
  LOVE_YA_LIKE_A_SISTER: 'Love Ya Like A Sister',
  LOVED_BY_THE_KING: 'Loved by the King',
  LOVERS_QUARREL: 'Lovers Quarrel',
  LUCKIEST_GUY: 'Luckiest Guy',
  LUSITANA: 'Lusitana',
  LUSTRIA: 'Lustria',
  LUXURIOUS_ROMAN: 'Luxurious Roman',
  LUXURIOUS_SCRIPT: 'Luxurious Script',
  M_PLUS_1: 'M PLUS 1',
  M_PLUS_1_CODE: 'M PLUS 1 Code',
  M_PLUS_1_P: 'M PLUS 1p',
  M_PLUS_2: 'M PLUS 2',
  M_PLUS_CODE_LATIN: 'M PLUS Code Latin',
  M_PLUS_ROUNDED_1_C: 'M PLUS Rounded 1c',
  MA_SHAN_ZHENG: 'Ma Shan Zheng',
  MACONDO: 'Macondo',
  MACONDO_SWASH_CAPS: 'Macondo Swash Caps',
  MADA: 'Mada',
  MAGRA: 'Magra',
  MAIDEN_ORANGE: 'Maiden Orange',
  MAITREE: 'Maitree',
  MAJOR_MONO_DISPLAY: 'Major Mono Display',
  MAKO: 'Mako',
  MALI: 'Mali',
  MALLANNA: 'Mallanna',
  MANDALI: 'Mandali',
  MANJARI: 'Manjari',
  MANROPE: 'Manrope',
  MANSALVA: 'Mansalva',
  MANUALE: 'Manuale',
  MARCELLUS: 'Marcellus',
  MARCELLUS_SC: 'Marcellus SC',
  MARCK_SCRIPT: 'Marck Script',
  MARGARINE: 'Margarine',
  MARKAZI_TEXT: 'Markazi Text',
  MARKO_ONE: 'Marko One',
  MARMELAD: 'Marmelad',
  MARTEL: 'Martel',
  MARTEL_SANS: 'Martel Sans',
  MARVEL: 'Marvel',
  MATE: 'Mate',
  MATE_SC: 'Mate SC',
  MAVEN_PRO: 'Maven Pro',
  MC_LAREN: 'McLaren',
  MEA_CULPA: 'Mea Culpa',
  MEDDON: 'Meddon',
  MEDIEVAL_SHARP: 'MedievalSharp',
  MEDULA_ONE: 'Medula One',
  MEERA_INIMAI: 'Meera Inimai',
  MEGRIM: 'Megrim',
  MEIE_SCRIPT: 'Meie Script',
  MEOW_SCRIPT: 'Meow Script',
  MERIENDA: 'Merienda',
  MERIENDA_ONE: 'Merienda One',
  MERRIWEATHER: 'Merriweather',
  MERRIWEATHER_SANS: 'Merriweather Sans',
  METAL: 'Metal',
  METAL_MANIA: 'Metal Mania',
  METAMORPHOUS: 'Metamorphous',
  METROPHOBIC: 'Metrophobic',
  MICHROMA: 'Michroma',
  MILONGA: 'Milonga',
  MILTONIAN: 'Miltonian',
  MILTONIAN_TATTOO: 'Miltonian Tattoo',
  MINA: 'Mina',
  MINIVER: 'Miniver',
  MIRIAM_LIBRE: 'Miriam Libre',
  MIRZA: 'Mirza',
  MISS_FAJARDOSE: 'Miss Fajardose',
  MITR: 'Mitr',
  MOCHIY_POP_ONE: 'Mochiy Pop One',
  MOCHIY_POP_P_ONE: 'Mochiy Pop P One',
  MODAK: 'Modak',
  MODERN_ANTIQUA: 'Modern Antiqua',
  MOGRA: 'Mogra',
  MOHAVE: 'Mohave',
  MOLENGO: 'Molengo',
  MONDA: 'Monda',
  MONOFETT: 'Monofett',
  MONOTON: 'Monoton',
  MONSIEUR_LA_DOULAISE: 'Monsieur La Doulaise',
  MONTAGA: 'Montaga',
  MONTAGU_SLAB: 'Montagu Slab',
  MONTE_CARLO: 'MonteCarlo',
  MONTEZ: 'Montez',
  MONTSERRAT: 'Montserrat',
  MONTSERRAT_ALTERNATES: 'Montserrat Alternates',
  MONTSERRAT_SUBRAYADA: 'Montserrat Subrayada',
  MOO_LAH_LAH: 'Moo Lah Lah',
  MOON_DANCE: 'Moon Dance',
  MOUL: 'Moul',
  MOULPALI: 'Moulpali',
  MOUNTAINS_OF_CHRISTMAS: 'Mountains of Christmas',
  MOUSE_MEMOIRS: 'Mouse Memoirs',
  MR_BEDFORT: 'Mr Bedfort',
  MR_DAFOE: 'Mr Dafoe',
  MR_DE_HAVILAND: 'Mr De Haviland',
  MRS_SAINT_DELAFIELD: 'Mrs Saint Delafield',
  MRS_SHEPPARDS: 'Mrs Sheppards',
  MUKTA: 'Mukta',
  MUKTA_MAHEE: 'Mukta Mahee',
  MUKTA_MALAR: 'Mukta Malar',
  MUKTA_VAANI: 'Mukta Vaani',
  MULISH: 'Mulish',
  MURECHO: 'Murecho',
  MUSEO_MODERNO: 'MuseoModerno',
  MYSTERY_QUEST: 'Mystery Quest',
  NTR: 'NTR',
  NANUM_BRUSH_SCRIPT: 'Nanum Brush Script',
  NANUM_GOTHIC: 'Nanum Gothic',
  NANUM_GOTHIC_CODING: 'Nanum Gothic Coding',
  NANUM_MYEONGJO: 'Nanum Myeongjo',
  NANUM_PEN_SCRIPT: 'Nanum Pen Script',
  NEONDERTHAW: 'Neonderthaw',
  NERKO_ONE: 'Nerko One',
  NEUCHA: 'Neucha',
  NEUTON: 'Neuton',
  NEW_ROCKER: 'New Rocker',
  NEW_TEGOMIN: 'New Tegomin',
  NEWS_CYCLE: 'News Cycle',
  NEWSREADER: 'Newsreader',
  NICONNE: 'Niconne',
  NIRAMIT: 'Niramit',
  NIXIE_ONE: 'Nixie One',
  NOBILE: 'Nobile',
  NOKORA: 'Nokora',
  NORICAN: 'Norican',
  NOSIFER: 'Nosifer',
  NOTABLE: 'Notable',
  NOTHING_YOU_COULD_DO: 'Nothing You Could Do',
  NOTICIA_TEXT: 'Noticia Text',
  NOTO_SANS: 'Noto Sans',
  NOTO_SANS_DISPLAY: 'Noto Sans Display',
  NOTO_SANS_HK: 'Noto Sans HK',
  NOTO_SANS_JP: 'Noto Sans JP',
  NOTO_SANS_KR: 'Noto Sans KR',
  NOTO_SANS_MONO: 'Noto Sans Mono',
  NOTO_SANS_SC: 'Noto Sans SC',
  NOTO_SANS_TC: 'Noto Sans TC',
  NOTO_SERIF: 'Noto Serif',
  NOTO_SERIF_DISPLAY: 'Noto Serif Display',
  NOTO_SERIF_JP: 'Noto Serif JP',
  NOTO_SERIF_KR: 'Noto Serif KR',
  NOTO_SERIF_SC: 'Noto Serif SC',
  NOTO_SERIF_TC: 'Noto Serif TC',
  NOVA_CUT: 'Nova Cut',
  NOVA_FLAT: 'Nova Flat',
  NOVA_MONO: 'Nova Mono',
  NOVA_OVAL: 'Nova Oval',
  NOVA_ROUND: 'Nova Round',
  NOVA_SCRIPT: 'Nova Script',
  NOVA_SLIM: 'Nova Slim',
  NOVA_SQUARE: 'Nova Square',
  NUMANS: 'Numans',
  NUNITO: 'Nunito',
  NUNITO_SANS: 'Nunito Sans',
  ODIBEE_SANS: 'Odibee Sans',
  ODOR_MEAN_CHEY: 'Odor Mean Chey',
  OFFSIDE: 'Offside',
  OI: 'Oi',
  OLD_STANDARD_TT: 'Old Standard TT',
  OLDENBURG: 'Oldenburg',
  OLE: 'Ole',
  OLEO_SCRIPT: 'Oleo Script',
  OLEO_SCRIPT_SWASH_CAPS: 'Oleo Script Swash Caps',
  OOOH_BABY: 'Oooh Baby',
  OPEN_SANS: 'Open Sans',
  ORANIENBAUM: 'Oranienbaum',
  ORBITRON: 'Orbitron',
  OREGANO: 'Oregano',
  ORELEGA_ONE: 'Orelega One',
  ORIENTA: 'Orienta',
  ORIGINAL_SURFER: 'Original Surfer',
  OSWALD: 'Oswald',
  OTOMANOPEE_ONE: 'Otomanopee One',
  OUTFIT: 'Outfit',
  OVER_THE_RAINBOW: 'Over the Rainbow',
  OVERLOCK: 'Overlock',
  OVERLOCK_SC: 'Overlock SC',
  OVERPASS: 'Overpass',
  OVERPASS_MONO: 'Overpass Mono',
  OVO: 'Ovo',
  OXANIUM: 'Oxanium',
  OXYGEN: 'Oxygen',
  OXYGEN_MONO: 'Oxygen Mono',
  PT_MONO: 'PT Mono',
  PT_SANS: 'PT Sans',
  PT_SANS_CAPTION: 'PT Sans Caption',
  PT_SANS_NARROW: 'PT Sans Narrow',
  PT_SERIF: 'PT Serif',
  PT_SERIF_CAPTION: 'PT Serif Caption',
  PACIFICO: 'Pacifico',
  PADAUK: 'Padauk',
  PALANQUIN: 'Palanquin',
  PALANQUIN_DARK: 'Palanquin Dark',
  PALETTE_MOSAIC: 'Palette Mosaic',
  PANGOLIN: 'Pangolin',
  PAPRIKA: 'Paprika',
  PARISIENNE: 'Parisienne',
  PASSERO_ONE: 'Passero One',
  PASSION_ONE: 'Passion One',
  PASSIONS_CONFLICT: 'Passions Conflict',
  PATHWAY_GOTHIC_ONE: 'Pathway Gothic One',
  PATRICK_HAND: 'Patrick Hand',
  PATRICK_HAND_SC: 'Patrick Hand SC',
  PATTAYA: 'Pattaya',
  PATUA_ONE: 'Patua One',
  PAVANAM: 'Pavanam',
  PAYTONE_ONE: 'Paytone One',
  PEDDANA: 'Peddana',
  PERALTA: 'Peralta',
  PERMANENT_MARKER: 'Permanent Marker',
  PETEMOSS: 'Petemoss',
  PETIT_FORMAL_SCRIPT: 'Petit Formal Script',
  PETRONA: 'Petrona',
  PHILOSOPHER: 'Philosopher',
  PIAZZOLLA: 'Piazzolla',
  PIEDRA: 'Piedra',
  PINYON_SCRIPT: 'Pinyon Script',
  PIRATA_ONE: 'Pirata One',
  PLASTER: 'Plaster',
  PLAY: 'Play',
  PLAYBALL: 'Playball',
  PLAYFAIR_DISPLAY: 'Playfair Display',
  PLAYFAIR_DISPLAY_SC: 'Playfair Display SC',
  PODKOVA: 'Podkova',
  POIRET_ONE: 'Poiret One',
  POLLER_ONE: 'Poller One',
  POLY: 'Poly',
  POMPIERE: 'Pompiere',
  PONTANO_SANS: 'Pontano Sans',
  POOR_STORY: 'Poor Story',
  POPPINS: 'Poppins',
  PORT_LLIGAT_SANS: 'Port Lligat Sans',
  PORT_LLIGAT_SLAB: 'Port Lligat Slab',
  POTTA_ONE: 'Potta One',
  PRAGATI_NARROW: 'Pragati Narrow',
  PRAISE: 'Praise',
  PRATA: 'Prata',
  PREAHVIHEAR: 'Preahvihear',
  PRESS_START_2_P: 'Press Start 2P',
  PRIDI: 'Pridi',
  PRINCESS_SOFIA: 'Princess Sofia',
  PROCIONO: 'Prociono',
  PROMPT: 'Prompt',
  PROSTO_ONE: 'Prosto One',
  PROZA_LIBRE: 'Proza Libre',
  PUBLIC_SANS: 'Public Sans',
  PUPPIES_PLAY: 'Puppies Play',
  PURITAN: 'Puritan',
  PURPLE_PURSE: 'Purple Purse',
  QAHIRI: 'Qahiri',
  QUANDO: 'Quando',
  QUANTICO: 'Quantico',
  QUATTROCENTO: 'Quattrocento',
  QUATTROCENTO_SANS: 'Quattrocento Sans',
  QUESTRIAL: 'Questrial',
  QUICKSAND: 'Quicksand',
  QUINTESSENTIAL: 'Quintessential',
  QWIGLEY: 'Qwigley',
  QWITCHER_GRYPEN: 'Qwitcher Grypen',
  RACING_SANS_ONE: 'Racing Sans One',
  RADLEY: 'Radley',
  RAJDHANI: 'Rajdhani',
  RAKKAS: 'Rakkas',
  RALEWAY: 'Raleway',
  RALEWAY_DOTS: 'Raleway Dots',
  RAMABHADRA: 'Ramabhadra',
  RAMARAJA: 'Ramaraja',
  RAMBLA: 'Rambla',
  RAMMETTO_ONE: 'Rammetto One',
  RAMPART_ONE: 'Rampart One',
  RANCHERS: 'Ranchers',
  RANCHO: 'Rancho',
  RANGA: 'Ranga',
  RASA: 'Rasa',
  RATIONALE: 'Rationale',
  RAVI_PRAKASH: 'Ravi Prakash',
  READEX_PRO: 'Readex Pro',
  RECURSIVE: 'Recursive',
  RED_HAT_DISPLAY: 'Red Hat Display',
  RED_HAT_MONO: 'Red Hat Mono',
  RED_HAT_TEXT: 'Red Hat Text',
  RED_ROSE: 'Red Rose',
  REDACTED: 'Redacted',
  REDACTED_SCRIPT: 'Redacted Script',
  REDRESSED: 'Redressed',
  REEM_KUFI: 'Reem Kufi',
  REENIE_BEANIE: 'Reenie Beanie',
  REGGAE_ONE: 'Reggae One',
  REVALIA: 'Revalia',
  RHODIUM_LIBRE: 'Rhodium Libre',
  RIBEYE: 'Ribeye',
  RIBEYE_MARROW: 'Ribeye Marrow',
  RIGHTEOUS: 'Righteous',
  RISQUE: 'Risque',
  ROAD_RAGE: 'Road Rage',
  ROBOTO: 'Roboto',
  ROBOTO_CONDENSED: 'Roboto Condensed',
  ROBOTO_MONO: 'Roboto Mono',
  ROBOTO_SERIF: 'Roboto Serif',
  ROBOTO_SLAB: 'Roboto Slab',
  ROCHESTER: 'Rochester',
  ROCK_3_D: 'Rock 3D',
  ROCK_SALT: 'Rock Salt',
  ROCKN_ROLL_ONE: 'RocknRoll One',
  ROKKITT: 'Rokkitt',
  ROMANESCO: 'Romanesco',
  ROPA_SANS: 'Ropa Sans',
  ROSARIO: 'Rosario',
  ROSARIVO: 'Rosarivo',
  ROUGE_SCRIPT: 'Rouge Script',
  ROWDIES: 'Rowdies',
  ROZHA_ONE: 'Rozha One',
  RUBIK: 'Rubik',
  RUBIK_BEASTLY: 'Rubik Beastly',
  RUBIK_MONO_ONE: 'Rubik Mono One',
  RUDA: 'Ruda',
  RUFINA: 'Rufina',
  RUGE_BOOGIE: 'Ruge Boogie',
  RULUKO: 'Ruluko',
  RUM_RAISIN: 'Rum Raisin',
  RUSLAN_DISPLAY: 'Ruslan Display',
  RUSSO_ONE: 'Russo One',
  RUTHIE: 'Ruthie',
  RYE: 'Rye',
  STIX_TWO_TEXT: 'STIX Two Text',
  SACRAMENTO: 'Sacramento',
  SAHITYA: 'Sahitya',
  SAIL: 'Sail',
  SAIRA: 'Saira',
  SAIRA_CONDENSED: 'Saira Condensed',
  SAIRA_EXTRA_CONDENSED: 'Saira Extra Condensed',
  SAIRA_SEMI_CONDENSED: 'Saira Semi Condensed',
  SAIRA_STENCIL_ONE: 'Saira Stencil One',
  SALSA: 'Salsa',
  SANCHEZ: 'Sanchez',
  SANCREEK: 'Sancreek',
  SANSITA: 'Sansita',
  SANSITA_SWASHED: 'Sansita Swashed',
  SARABUN: 'Sarabun',
  SARALA: 'Sarala',
  SARINA: 'Sarina',
  SARPANCH: 'Sarpanch',
  SASSY_FRASS: 'Sassy Frass',
  SATISFY: 'Satisfy',
  SAWARABI_GOTHIC: 'Sawarabi Gothic',
  SAWARABI_MINCHO: 'Sawarabi Mincho',
  SCADA: 'Scada',
  SCHEHERAZADE_NEW: 'Scheherazade New',
  SCHOOLBELL: 'Schoolbell',
  SCOPE_ONE: 'Scope One',
  SEAWEED_SCRIPT: 'Seaweed Script',
  SECULAR_ONE: 'Secular One',
  SEDGWICK_AVE: 'Sedgwick Ave',
  SEDGWICK_AVE_DISPLAY: 'Sedgwick Ave Display',
  SEN: 'Sen',
  SEVILLANA: 'Sevillana',
  SEYMOUR_ONE: 'Seymour One',
  SHADOWS_INTO_LIGHT: 'Shadows Into Light',
  SHADOWS_INTO_LIGHT_TWO: 'Shadows Into Light Two',
  SHALIMAR: 'Shalimar',
  SHANTI: 'Shanti',
  SHARE: 'Share',
  SHARE_TECH: 'Share Tech',
  SHARE_TECH_MONO: 'Share Tech Mono',
  SHIPPORI_ANTIQUE: 'Shippori Antique',
  SHIPPORI_ANTIQUE_B_1: 'Shippori Antique B1',
  SHIPPORI_MINCHO: 'Shippori Mincho',
  SHIPPORI_MINCHO_B_1: 'Shippori Mincho B1',
  SHIZURU: 'Shizuru',
  SHOJUMARU: 'Shojumaru',
  SHORT_STACK: 'Short Stack',
  SHRIKHAND: 'Shrikhand',
  SIGMAR_ONE: 'Sigmar One',
  SIGNIKA: 'Signika',
  SIGNIKA_NEGATIVE: 'Signika Negative',
  SIMONETTA: 'Simonetta',
  SINTONY: 'Sintony',
  SIRIN_STENCIL: 'Sirin Stencil',
  SIX_CAPS: 'Six Caps',
  SKRANJI: 'Skranji',
  SLABO_13_PX: 'Slabo 13px',
  SLABO_27_PX: 'Slabo 27px',
  SLACKEY: 'Slackey',
  SMOKUM: 'Smokum',
  SMOOCH: 'Smooch',
  SMOOCH_SANS: 'Smooch Sans',
  SMYTHE: 'Smythe',
  SNIGLET: 'Sniglet',
  SNIPPET: 'Snippet',
  SNOWBURST_ONE: 'Snowburst One',
  SOFADI_ONE: 'Sofadi One',
  SOFIA: 'Sofia',
  SOLWAY: 'Solway',
  SONG_MYUNG: 'Song Myung',
  SONSIE_ONE: 'Sonsie One',
  SORA: 'Sora',
  SORTS_MILL_GOUDY: 'Sorts Mill Goudy',
  SOURCE_CODE_PRO: 'Source Code Pro',
  SOURCE_SANS_3: 'Source Sans 3',
  SOURCE_SANS_PRO: 'Source Sans Pro',
  SOURCE_SERIF_4: 'Source Serif 4',
  SOURCE_SERIF_PRO: 'Source Serif Pro',
  SPACE_GROTESK: 'Space Grotesk',
  SPACE_MONO: 'Space Mono',
  SPARTAN: 'Spartan',
  SPECIAL_ELITE: 'Special Elite',
  SPECTRAL: 'Spectral',
  SPECTRAL_SC: 'Spectral SC',
  SPICY_RICE: 'Spicy Rice',
  SPINNAKER: 'Spinnaker',
  SPIRAX: 'Spirax',
  SPLINE_SANS: 'Spline Sans',
  SQUADA_ONE: 'Squada One',
  SREE_KRUSHNADEVARAYA: 'Sree Krushnadevaraya',
  SRIRACHA: 'Sriracha',
  SRISAKDI: 'Srisakdi',
  STAATLICHES: 'Staatliches',
  STALEMATE: 'Stalemate',
  STALINIST_ONE: 'Stalinist One',
  STARDOS_STENCIL: 'Stardos Stencil',
  STICK: 'Stick',
  STICK_NO_BILLS: 'Stick No Bills',
  STINT_ULTRA_CONDENSED: 'Stint Ultra Condensed',
  STINT_ULTRA_EXPANDED: 'Stint Ultra Expanded',
  STOKE: 'Stoke',
  STRAIT: 'Strait',
  STYLE_SCRIPT: 'Style Script',
  STYLISH: 'Stylish',
  SUE_ELLEN_FRANCISCO: 'Sue Ellen Francisco',
  SUEZ_ONE: 'Suez One',
  SULPHUR_POINT: 'Sulphur Point',
  SUMANA: 'Sumana',
  SUNSHINEY: 'Sunshiney',
  SUPERMERCADO_ONE: 'Supermercado One',
  SURA: 'Sura',
  SURANNA: 'Suranna',
  SURAVARAM: 'Suravaram',
  SUWANNAPHUM: 'Suwannaphum',
  SWANKY_AND_MOO_MOO: 'Swanky and Moo Moo',
  SYNCOPATE: 'Syncopate',
  SYNE: 'Syne',
  SYNE_MONO: 'Syne Mono',
  SYNE_TACTILE: 'Syne Tactile',
  TAJAWAL: 'Tajawal',
  TANGERINE: 'Tangerine',
  TAPROM: 'Taprom',
  TAURI: 'Tauri',
  TAVIRAJ: 'Taviraj',
  TEKO: 'Teko',
  TELEX: 'Telex',
  TENALI_RAMAKRISHNA: 'Tenali Ramakrishna',
  TENOR_SANS: 'Tenor Sans',
  TEXT_ME_ONE: 'Text Me One',
  TEXTURINA: 'Texturina',
  THASADITH: 'Thasadith',
  THE_GIRL_NEXT_DOOR: 'The Girl Next Door',
  THE_NAUTIGAL: 'The Nautigal',
  TIENNE: 'Tienne',
  TILLANA: 'Tillana',
  TIMMANA: 'Timmana',
  TINOS: 'Tinos',
  TITAN_ONE: 'Titan One',
  TITILLIUM_WEB: 'Titillium Web',
  TOMORROW: 'Tomorrow',
  TOURNEY: 'Tourney',
  TRADE_WINDS: 'Trade Winds',
  TRAIN_ONE: 'Train One',
  TRIRONG: 'Trirong',
  TRISPACE: 'Trispace',
  TROCCHI: 'Trocchi',
  TROCHUT: 'Trochut',
  TRUCULENTA: 'Truculenta',
  TRYKKER: 'Trykker',
  TULPEN_ONE: 'Tulpen One',
  TURRET_ROAD: 'Turret Road',
  TWINKLE_STAR: 'Twinkle Star',
  UBUNTU: 'Ubuntu',
  UBUNTU_CONDENSED: 'Ubuntu Condensed',
  UBUNTU_MONO: 'Ubuntu Mono',
  UCHEN: 'Uchen',
  ULTRA: 'Ultra',
  UNCIAL_ANTIQUA: 'Uncial Antiqua',
  UNDERDOG: 'Underdog',
  UNICA_ONE: 'Unica One',
  UNIFRAKTUR_MAGUNTIA: 'UnifrakturMaguntia',
  UNKEMPT: 'Unkempt',
  UNLOCK: 'Unlock',
  UNNA: 'Unna',
  URBANIST: 'Urbanist',
  VT_323: 'VT323',
  VAMPIRO_ONE: 'Vampiro One',
  VARELA: 'Varela',
  VARELA_ROUND: 'Varela Round',
  VARTA: 'Varta',
  VAST_SHADOW: 'Vast Shadow',
  VESPER_LIBRE: 'Vesper Libre',
  VIAODA_LIBRE: 'Viaoda Libre',
  VIBES: 'Vibes',
  VIBUR: 'Vibur',
  VIDALOKA: 'Vidaloka',
  VIGA: 'Viga',
  VOCES: 'Voces',
  VOLKHOV: 'Volkhov',
  VOLLKORN: 'Vollkorn',
  VOLLKORN_SC: 'Vollkorn SC',
  VOLTAIRE: 'Voltaire',
  VUJAHDAY_SCRIPT: 'Vujahday Script',
  WAITING_FOR_THE_SUNRISE: 'Waiting for the Sunrise',
  WALLPOET: 'Wallpoet',
  WALTER_TURNCOAT: 'Walter Turncoat',
  WARNES: 'Warnes',
  WATERFALL: 'Waterfall',
  WELLFLEET: 'Wellfleet',
  WENDY_ONE: 'Wendy One',
  WIND_SONG: 'WindSong',
  WIRE_ONE: 'Wire One',
  WORK_SANS: 'Work Sans',
  XANH_MONO: 'Xanh Mono',
  YALDEVI: 'Yaldevi',
  YANONE_KAFFEESATZ: 'Yanone Kaffeesatz',
  YANTRAMANAV: 'Yantramanav',
  YATRA_ONE: 'Yatra One',
  YELLOWTAIL: 'Yellowtail',
  YEON_SUNG: 'Yeon Sung',
  YESEVA_ONE: 'Yeseva One',
  YESTERYEAR: 'Yesteryear',
  YOMOGI: 'Yomogi',
  YRSA: 'Yrsa',
  YUJI_BOKU: 'Yuji Boku',
  YUJI_HENTAIGANA_AKARI: 'Yuji Hentaigana Akari',
  YUJI_HENTAIGANA_AKEBONO: 'Yuji Hentaigana Akebono',
  YUJI_MAI: 'Yuji Mai',
  YUJI_SYUKU: 'Yuji Syuku',
  YUSEI_MAGIC: 'Yusei Magic',
  ZCOOL_KUAI_LE: 'ZCOOL KuaiLe',
  ZCOOL_QING_KE_HUANG_YOU: 'ZCOOL QingKe HuangYou',
  ZCOOL_XIAO_WEI: 'ZCOOL XiaoWei',
  ZEN_ANTIQUE: 'Zen Antique',
  ZEN_ANTIQUE_SOFT: 'Zen Antique Soft',
  ZEN_DOTS: 'Zen Dots',
  ZEN_KAKU_GOTHIC_ANTIQUE: 'Zen Kaku Gothic Antique',
  ZEN_KAKU_GOTHIC_NEW: 'Zen Kaku Gothic New',
  ZEN_KURENAIDO: 'Zen Kurenaido',
  ZEN_LOOP: 'Zen Loop',
  ZEN_MARU_GOTHIC: 'Zen Maru Gothic',
  ZEN_OLD_MINCHO: 'Zen Old Mincho',
  ZEN_TOKYO_ZOO: 'Zen Tokyo Zoo',
  ZEYADA: 'Zeyada',
  ZHI_MANG_XING: 'Zhi Mang Xing',
  ZILLA_SLAB: 'Zilla Slab',
  ZILLA_SLAB_HIGHLIGHT: 'Zilla Slab Highlight',
};

export default WebFontsEnum;
